import { render, staticRenderFns } from "./KonfirmasiTransfer.vue?vue&type=template&id=3ba21c0a&scoped=true&"
import script from "./KonfirmasiTransfer.vue?vue&type=script&lang=js&"
export * from "./KonfirmasiTransfer.vue?vue&type=script&lang=js&"
import style0 from "./KonfirmasiTransfer.vue?vue&type=style&index=0&id=3ba21c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba21c0a",
  null
  
)

export default component.exports